import { render, staticRenderFns } from "./ListarVentasNoEntregadas.vue?vue&type=template&id=8cbfa052&"
import script from "./ListarVentasNoEntregadas.vue?vue&type=script&lang=js&"
export * from "./ListarVentasNoEntregadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports